import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import { CONTAINER_TYPES } from "../../infrastructure/ioc/container-types";
import ServiceInterface from "@/vue/service/service-interface";
import DfContent from "@/vue/domain/content/df-content";
import DfProperty from "@/vue/domain/content/df-property";
import Utils from "@/vue/infrastructure/utils/helpers";
import { Carousel, Slide } from "vue-carousel-variable-width";
import DfStore from "@/vue/domain/store/df-store";
import DfBrand from "@/vue/domain/brand/df-brand";
import DfPromotion from "@/vue/domain/promotion/df-promotion";

@Component({
  components: {
    Carousel,
    Slide,
  },
})
export default class DfSectionBannerComponent extends Vue {
  @Inject(CONTAINER_TYPES.ServiceInterface)
  private service!: ServiceInterface;

  @Prop({
    type: Array,
    default: () => {
      [];
    },
  })
  banners!: Array<DfContent>;

  @Prop({ type: String, default: "" })
  position!: string;
  @Prop({ type: Boolean, default: false })
  carouselView!: boolean;
  @Prop({ type: Boolean, default: false })
  fullWidth!: boolean;
  @Prop({ type: Boolean, default: true })
  columnDirection!: boolean;
  @Prop({ type: Boolean, default: false })
  showGamAdvSelex!: boolean;

  bannersTracked: Array<string> = [];
  clickPoint: any = {
    x: 0,
    y: 0,
  }

  get brand(): DfBrand {
    return this.$store.getters.brand;
  }

  get currentPromotion(): DfPromotion {
    return this.$store.getters.currentPromotion;
  }

  get currentStore(): DfStore {
    return this.$store.getters.currentStore;
  }

  get carouselAutoplay(): string {
    return Utils.getPropertyValue(this.brand, Utils.PROPERTY_CAROUSEL_AUTOPLAY, "BOOLEAN");
  }

  get bannersFiletred(): Array<DfContent> {
    return this.banners.filter((banner: DfContent) => {
      const positionValue: any = Utils.getPropertyValue(banner, Utils.PROPERTY_POSITION, "LIST", {});
      const filteredByPosition: boolean = positionValue.key === "ALL" || positionValue.key === this.position;

      const targetValue: any = Utils.getPropertyValue(banner, Utils.PROPERTY_TARGET_DEVICE, "LIST", { key: "ALL" });
      const checkTargetDevice: boolean = Utils.isMobile() ? targetValue.key === "MOBILE" : targetValue.key === "DESKTOP";
      const filteredByTarget: boolean = targetValue.key === "ALL" || checkTargetDevice;

      return filteredByPosition && filteredByTarget;
    });
  }

  get bannersToShow(): Array<any> {
    const bannersToShow: Array<any> = [];
    this.bannersFiletred.forEach((banner: DfContent) => {
      const previewMobileUrl: string = Utils.getPropertyImageUrl(banner, Utils.PROPERTY_PREVIEW_MOBILE, null);
      const previewProperty: DfProperty = Utils.isMobile() && previewMobileUrl ? banner.properties.find((property: DfProperty) => property.code === Utils.PROPERTY_PREVIEW_MOBILE) : banner.properties.find((property: DfProperty) => property.code === Utils.PROPERTY_PREVIEW);
      const propertyLink: DfProperty = banner.properties ? banner.properties.find((property: DfProperty) => property.code === Utils.PROPERTY_LINK) || null : null;

      if (previewProperty && previewProperty.values.length > 0) {
        bannersToShow.push({
          previewUrl: `${Utils.getEndpointContextPath()}/files/${previewProperty.values[0].uniqueId}/${previewProperty.values[0].basename}.${previewProperty.values[0].extension}`,
          linkUrl: propertyLink && propertyLink.values.length > 0 ? propertyLink.values[0] : null,
          name: banner.name,
        });
      }
    });

    return bannersToShow;
  }

  get gamAdvSelexEnabled(): boolean {
    return Utils.gamAdvSelexEnabled();
  }

  get gamAdvSelexEnvironment(): string {
    return Utils.gamAdvSelexEnvironment();
  }

  get gamAdvSelexBrand(): string {
    return Utils.gamAdvSelexBrand();
  }

  get isGamAdvSelexHeader(): boolean {
    return this.gamAdvSelexEnabled && this.showGamAdvSelex && this.position === "HEADER";
  }

  get isMobile(): boolean {
    return Utils.isMobile();
  }

  @Watch("bannersToShow", { immediate: true })
  private changeVisibility() {
    this.$emit("setVisibility", this.bannersToShow.length > 0);
  }

  updated() {
    if (this.gamAdvSelexEnabled) {
      const event = new Event("updateDOMContent");
      document.dispatchEvent(event);
    }
  }

  private onMouseDown(event: any) {
    // Salva la posizione iniziale del mouse
    this.clickPoint.x = event.clientX;
    this.clickPoint.y = event.clientY;
  }

  private onMouseUp(event: any, banner: any) {
    const diffX = Math.abs(event.clientX - this.clickPoint.x);
    const diffY = Math.abs(event.clientY - this.clickPoint.y);
    if (diffX > 5 || diffY > 5) {
      event.preventDefault();
      return;
    }
    this.onClick(banner);
  }

  private onClick(banner: any) {
    if (banner && banner.linkUrl) {
      Utils.setAnaliticsTraker({
        event: "click_banner",
        origin: "smt-digitalflyer-ui",
        name: banner.name,
        type: "banner",
        storeAlias: this.currentStore.alias,
        storeCode: this.currentStore.code,
        storeName: this.currentStore.name,
      });

      Utils.setAnaliticsTraker({
        event: "select_promotion",
        ecommerce: {
          items: [
            {
              item_name: `promo_${this.currentPromotion.description?.replaceAll(" ", "-")}`, //e.g promo_natale-cuore
              item_type: "promo",
              creative_name: this.banners.length > 1 ? "carousel" : "box",
              creative_slot: "locale", //"locale|nazionale",
              promotion_name: `promo_${this.currentPromotion.description?.replaceAll(" ", "-")}`, //e.g promo_natale-cuore
              quantity: 1, // quantità fissa
            },
          ],
        },
      });
      Utils.isExternalLink(banner.linkUrl) ? window.open(banner.linkUrl, "_blank") : this.$router.push({ path: banner.linkUrl.startsWith("/") ? banner.linkUrl : `/${banner.linkUrl}` });
    }
  }

  get trackBanners(): boolean {
    const trakerData: Array<any> = [];

    this.bannersToShow.map((bannerToShow) => {
      const banner:DfContent = this.banners.find((banner) => banner.name === bannerToShow.name)
      if (banner && !this.bannersTracked.includes(banner.uniqueId)) {
        this.bannersTracked.push(banner.uniqueId);
        trakerData.push({
          item_name: `promo_${this.currentPromotion.description?.replaceAll(" ", "-")}`, //e.g promo_natale-cuore
          item_type: "promo",
          creative_name: this.banners.length > 1 ? "carousel" : "box",
          creative_slot: "locale", //"locale|nazionale",
          promotion_name: `promo_${this.currentPromotion.description?.replaceAll(" ", "-")}`, //e.g promo_natale-cuore
          quantity: 1, // quantità fissa
        });
      }
    });

    if (trakerData.length > 0) {
      Utils.setAnaliticsTraker({
        event: "view_promotion",
        ecommerce: {
          items: trakerData,
        },
      });
    }

    return true;
  }
}
